import { useState, useEffect, useCallback } from 'react';
import { attemptsService } from '../services/attempts.service';
import { AttemptHistoryResponse } from '../types';

export function useAttemptHistory(simulationId: string | undefined) {
  const [data, setData] = useState<AttemptHistoryResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchHistory = useCallback(async () => {
    if (!simulationId) {
      setData(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await attemptsService.getSimulationAttemptHistory(simulationId);
      setData(response);
    } catch (err: any) {
      setError(err?.message || 'Failed to load attempt history');
    } finally {
      setLoading(false);
    }
  }, [simulationId]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return {
    simulation: data?.simulation,
    attempts: data?.attempts || [],
    totalAttempts: data?.totalAttempts || 0,
    quota: data?.quota,
    loading,
    error,
    refresh: fetchHistory,
  };
}
